import * as React from "react";
import {
    ICustomerPortalService,
    IncludedProductsEnum,
    Party,
    Policy,
    productHelper,
    ProductsEnum,
    Subscription,
    Types,
    INTERACTION_PROCESS_MTA_REPLACE_CAR,
    POLICY_STATUS_MTC
} from "@falcon/services";
import {authorize, Overlay} from "@athena-portal/components";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import {YourCarCoverPanel} from "./YourCarCoverPanel";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import {ButtonLink} from "../../../../../components/navigation/ButtonLink";
import * as moment from "moment";
import {RouteComponentProps} from "react-router";
import {StorageSuccessModal} from "../../../../../components/modals/StorageSuccessModal";
import {EditCarMtaSuccessModalWordingGenerator} from "../../../annual/motor/yourCarsPage/modal/EditCarMtaSuccessModalWordingGenerator";
import {getAmountToDisplay} from "../../../../../CommonFunctions";

interface IYourCarCoversPageParams {
    policyNumber: string;
}

interface IYourCarCoversPageProps extends RouteComponentProps<IYourCarCoversPageParams> {
    location: any;
}

interface IState {
    policies?: Policy[];
    allPolicies?: Policy[];
    subscription?: Subscription;
    party?: Party;
    referrerJourney: string | null;
    additionalPremium: string | null;
    returnPremium: string | null;
    showSuccessPopup: string | null;
}

@authorize
export class YourCarCoversPage extends React.Component<IYourCarCoversPageProps, IState> {

    private pluginTemplates = new PluginTemplates();

    private modalContent: JSX.Element;
    private modalTitle: string;

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IYourCarCoversPageProps) {
        super(props);

        this.state = {
            referrerJourney: null,
            additionalPremium: null,
            returnPremium: null,
            showSuccessPopup: null
        };

        this.loadSession = this.loadSession.bind(this);
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Your car covers");

        this.customerPortalService.getPolicies(ProductsEnum.MOTOR).subscribe(
            (policies: Policy[]) => {
                this.setState({
                    policies
                });

                if (policies && policies.length > 0) {
                    this.customerPortalService.getSubscription().subscribe((subscription: Subscription) => {
                        this.setState({
                            subscription
                        });
                    });
                }
            }
        )

        this.customerPortalService.getPolicyHistory().subscribe(
            (allPolicies: Policy[]) => {
                this.setState({allPolicies})
            }
        );

        this.customerPortalService.getProfile().subscribe((output: Party) => {
            this.setState({
                party: output
            })
        });

        this.loadSession();
    }

    public render() {
        const {subscription, party} = this.state;
        const dataLoaded = subscription && party;

        if (this.state.referrerJourney === "mtaChangePolicyHolderAdditionalDetails") {
            this.setChangePolicyHolderAdditionalDetailsPopup();
        }

        if (this.state.policies) {
            const includedProducts = productHelper.getIncludedProducts(this.state.policies);
            const vehiclePoliciesExist: boolean = includedProducts === IncludedProductsEnum.MOTOR + IncludedProductsEnum.RENTERS || includedProducts === IncludedProductsEnum.MOTOR;
            return (
                <React.Fragment>
                    {this.state.showSuccessPopup &&
                        <StorageSuccessModal title={this.modalTitle}
                            explanationWording={this.modalContent}
                            anythingElseTitle={EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle()}
                            explanationAnythingElseWording={EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody()}
                            onClose={this.loadSession}/>
                    }
                    <FalconHeader/>
                    {!vehiclePoliciesExist &&
                    <div className="page-contents">
                        {this.pluginTemplates.renderBackLink("Back", true, "/dashboard/monthlySubscription")}
                        <div className={"panel"}>
                            You haven’t covered any cars yet.
                        </div>
                        {this.pluginTemplates.renderBackLink("Back", true, "/dashboard/monthlySubscription")}
                    </div>}
                    {vehiclePoliciesExist &&
                    <React.Fragment>
                        <Overlay show={!dataLoaded}/>
                        <div className="page-contents">
                        {this.pluginTemplates.renderBackLink("Back", true, "/dashboard/monthlySubscription")}
                        <h1 className="page-heading-white">{this.state.policies && this.state.policies.length === 1 ? "Your car cover" : "Your car covers"}</h1>
                        {dataLoaded && this.renderPageContents()}
                        {this.pluginTemplates.renderBackLink("Back", false, "/dashboard/monthlySubscription")}
                        </div>
                    </React.Fragment>}
                    <FalconFooter/>
                </React.Fragment>
            );
        } else {
            return <Overlay show={true}/>
        }
    }

    private renderPageContents(): JSX.Element {
        const {subscription} = this.state;
        const rentersEnabled: boolean = process.env.REACT_APP_RENTERS_ENABLED ? JSON.parse(process.env.REACT_APP_RENTERS_ENABLED) : true;

        if (rentersEnabled) {
            if (subscription!.includedProducts === IncludedProductsEnum.MOTOR + IncludedProductsEnum.RENTERS) {
                return (
                    <React.Fragment>
                        {this.renderYourCarCoverPanels()}
                        {this.state.policies?.filter(policy => policy.status !== POLICY_STATUS_MTC).length === 0 ? (
                            this.renderReactivationButton()
                        ):(
                            <ButtonLink
                                id="cancelCarCovers"
                                primary={true}
                                to="/journey/init/product/MotorInsurance/process/mtc"
                            >Cancel all car covers</ButtonLink>
                        )}
                    </React.Fragment>
                )
            } else {
                return <>{this.renderYourCarCoverPanels()}</>
            }
        } else {
            return (
                <React.Fragment>
                    {this.renderYourCarCoverPanels()}
                    {subscription!.allPoliciesAreCancelled ? (
                        <>
                            {(!subscription!.cancellationUWFailure && !subscription!.allMTCsAreFromSupportPortal) && (
                                <ButtonLink
                                    id="reactivateSubscription"
                                    primary={true}
                                    to="/journey/show/product/MotorInsurance/process/mtaReinstateSubscription/initializeInteraction"
                                >Reactivate subscription</ButtonLink>
                            )}

                        </>
                    ):(
                        <ButtonLink
                            id="cancelSubscription"
                            primary={true}
                            to="/journey/init/product/MotorInsurance/process/mtc"
                        >Cancel subscription</ButtonLink>
                    )}
                </React.Fragment>
            )
        }
    }

    private renderReactivationButton(): JSX.Element {
        if (this.state.subscription?.allPoliciesAreCancelled || this.state.subscription?.allMotorsMTCsAreFromSupportPortal) {
            return <></>
        } else {
            return (
                <ButtonLink
                    id="reactivateCarCovers"
                    primary={true}
                    to="/journey/show/product/MotorInsurance/process/mtaReinstateAllCars/initializeInteraction"
                >Reactivate all car covers</ButtonLink>
            )
        }
    }

    private renderYourCarCoverPanels(): JSX.Element[] | void {
        const {policies, allPolicies, subscription, party} = this.state;

        if (!(policies && allPolicies && subscription && party)) {
            return;
        }

        return policies!.map((policy: Policy, index: number) => {
            let replacedPolicy: Policy | undefined;
            if (policy.interaction.process === INTERACTION_PROCESS_MTA_REPLACE_CAR && moment().isBefore(policy.interaction.headerInfo.startDate)) {
                replacedPolicy = this.state.allPolicies!.find(p => p.policyNumber === this.props.match.params.policyNumber && p.interaction.agreementVersion === policy.interaction.agreementVersion - 1);
            }

            return (
                <YourCarCoverPanel
                    {...this.props}
                    key={index}
                    policy={policy}
                    replacedPolicy={replacedPolicy}
                    subscription={subscription!}
                    vehicleIndex={index}
                    party={party}
                />
            );
        });
    }

    private loadSession() {
        this.setState({
            showSuccessPopup: window.sessionStorage.getItem("showPopup"),
            referrerJourney: window.sessionStorage.getItem("referrerJourney"),
            additionalPremium: window.sessionStorage.getItem("additionalPremium"),
            returnPremium: window.sessionStorage.getItem("returnPremium")
        });
    }

    private setChangePolicyHolderAdditionalDetailsPopup = () : void  => {

        if (this.state.returnPremium && this.state.returnPremium !== "0") {
            this.modalTitle = "Your refund is on the way";
            this.modalContent =
                <p>
                    We’ve saved your changes, and we’ll refund you <b>{getAmountToDisplay(this.state.returnPremium)}</b> for changes you've made.
                    Please allow two days for it to arrive.
                </p>;
        } else if (this.state.additionalPremium && this.state.additionalPremium !== "0") {
            this.modalTitle = "Payment successful";
            this.modalContent =
                <p>
                    We’ve saved your changes and <b>{getAmountToDisplay(this.state.additionalPremium)}</b> has been debited from your card.
                </p>;
        } else {
            this.setAllDonePopup();
        }
    };

    private setAllDonePopup = () : void => {
        this.modalTitle = "All done";
        this.modalContent =
            <p>
                We’ve saved your changes.
            </p>;
    };
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/subscription/motor/yourCarCoversPage/YourCarCoversPage.tsx